import axios from 'axios';
import qs from 'qs';
import { baseURL, ENV } from "../utils/index";
import store from '../store';

const instance = axios.create({
  baseURL,
  headers: { 'content-type': 'application/x-www-form-urlencoded' }
})

let loginInstance = axios.create({
  baseURL: store.state.globalServer.data.service + '/' + ENV,
  headers: { 'content-type': 'application/x-www-form-urlencoded' }
});

loginInstance.interceptors.request.use(async function (config) {
  if (store.state.globalServer.hasRequest) {
    return config;
  }
  const response = await axios.get('https://demos.trtc.tencent-cloud.com/prod/base/v1/gslb');
  store.commit('getGlobalServerSuccess', response.data.data);
  const { service } = response.data.data;
  config.baseURL = service + '/' + ENV;
  return config;
});

export async function getSmsVerifyCode(data) {
  data.appId = store.state.globalServer.data.captcha_web_appid;
  const options = buildOptions(data, '/base/v1/auth_users/user_verify_by_picture', 'GET')
  return loginInstance(options);
}

export async function loginSystemByVerifyCode(loginInfo) {
  const options = buildOptions(loginInfo, '/base/v1/auth_users/user_login_code');
  return loginInstance(options);
}

export async function loginSystemByToken(data) {
  const options = buildOptions(data, '/base/v1/auth_users/user_login_token');
  return loginInstance(options);
}

export async function fetchUserInfoByPhone(phone, token) {
  let data = {
    phone,
    token
  };
  const options = buildOptions(data, '/release/getUserInfo');
  return instance(options);
}

export async function fetchUserInfoByUserId(userId, token) {
  let data = {
    userId,
    token
  };
  const options = buildOptions(data, '/release/getUserInfo');
  return instance(options);
}

export async function updateUserName(data) {
  const options = buildOptions(data, '/base/v1/auth_users/user_update');
  return loginInstance(options);
}

function buildOptions(data, url, method) {
  const options = {
    method: method || 'POST',
    url
  }
  if (options.method === 'GET') {
    options.params = data
  } else {
    options.data = qs.stringify(data)
  }
  return options
}
